import { useQuery, useMutation } from "@tanstack/react-query";
import {
  apiDelete,
  apiGet,
  apiPost,
  apiPostFormData,
  apiUpdate,
} from "api/api-ccp";

// ✅ Generic Fetch Hook
export const useFetch = (key, url, params = {}) => {
  return useQuery({
    queryKey: [key, params], // ✅ React Query will detect changes
    queryFn: () => apiGet(url, params),
    keepPreviousData: true, // Prevents unnecessary loading states during pagination
    staleTime: 300000, // Cache data for 5 minutes
    cacheTime: 10 * 60 * 1000,
    retry: 2,
  });
};

export const usePost = (key, url, headerType) => {
  return useMutation({
    mutationFn: (data) => {
      return apiPost(url, data, headerType);
    },
    onError: (error) => {
      console.error(`${key} error:`, error);
    },
  });
};

export const useUpdate = (key, url) => {
  return useMutation({
    mutationFn: ({ params, data }) => {
      const queryParams = new URLSearchParams(params).toString();
      console.log("params", queryParams);
      return apiUpdate(`${url}${queryParams ? `?${queryParams}` : ""}`, data); // ✅ Append params dynamically
    },
    onError: (error) => {
      console.error(`${key} update error:`, error);
    },
  });
};
export const useUpdateComment = (key, url) => {
  return useMutation({
    mutationFn: ({ params, data }) => {
      console.log("params", params);
      const queryParams = new URLSearchParams(params).toString();
      return apiUpdate(`${url}`, data); // ✅ Append params dynamically
    },
    onError: (error) => {
      console.error(`${key} update error:`, error);
    },
  });
};

export const useDelete = (key, url) => {
  return useMutation({
    mutationFn: (params) => {
      const queryParams = new URLSearchParams(params).toString();
      return apiDelete(`${url}${queryParams ? `?${queryParams}` : ""}`);
    },
    onError: (error) => {
      console.error(`${key} delete error:`, error);
    },
  });
};
export const useDeleteImage = (key, url) => {
  return useMutation({
    mutationFn: (params) => {

      return apiDelete(`${url}?ImageId=${params.imageID}`); // ✅ Correct URL format
    },
    onError: (error) => {
      console.error(`${key} delete error:`, error);
    },
  });
};
export const useDeleteDocument = (key, url) => {
  return useMutation({
    mutationFn: (params) => {
      // console.log(params,"params")
      console.log(params);
      // const [paramKey, paramValue] = Object.entries(params)[0]; // ✅ Extract first key-value pair dynamically
      return apiDelete(`${url}?DocumentId=${params.documentId}`); // ✅ Correct URL format
    },
    onError: (error) => {
      console.error(`${key} delete error:`, error);
    },
  });
};

// ✅ New function for POST requests with FormData

// ✅ New hook for POST requests with FormData
export const usePostFormData = (key, url) => {
  return useMutation({
    mutationFn: (formData) => apiPostFormData(url, formData),
    onError: (error) => {
      console.error(`${key} error:`, error);
    },
  });
};
